import './styles/logo.scss';
import clsx from "clsx";

const Logo = ({ className }) => {
    return (
        <div className={clsx('logo-root', className)}>
            <h2 className='inter-medium'><span className='logo-accent'>MAXX</span>BET360</h2>
        </div>
    )
}

export default Logo;